import { Component, Prop } from 'vue-property-decorator';

import Vue from 'vue';
import { t } from 'i18next';
import template from './Search.vue';

@Component({
	mixins: [template]
})
export default class Search extends Vue {
	@Prop() loading: boolean = false;

	@Prop() value: string = '';

	@Prop({ default: t('placeholders.start-searching') }) readonly label!: string;

	@Prop({ default: '' }) readonly placeholder!: string;

	search(searchWord: string): void {
		if (this.value === searchWord) {
			return;
		}

		if (searchWord === '') {
			// Default back.
			this.$emit('newSearch');
		} else {
			this.$emit('newSearch', searchWord);
		}
	}
}
